<div class="tp">
  <div class="tp-titulo">
    <span class="onb-ic onb-ic--ok"><i class="fas fa-check"></i></span>
    <h1>Sua loja está pronta para vender</h1>
  </div>

  <app-onb-bonus [estado]="estado" formato="destaque"></app-onb-bonus>

  <p class="onb-sub tp-sub">Agora é fazer o cliente chegar até ela. Três jeitos que funcionam no primeiro dia:</p>

  <div class="onb-grupo-rot">Seu link</div>
  <div class="onb-grupo">
    <div class="onb-linha">
      <div class="tp-link"><span>{{ linkCurto }}</span></div>
      <button type="button" class="onb-btn onb-btn--pri" (click)="copie(link, 'link')"><i class="far fa-copy"></i> {{ copiado === 'link' ? 'Copiado' : 'Copiar' }}</button>
    </div>
  </div>

  <div class="onb-grupo-rot">Para mandar hoje</div>
  <div class="onb-grupo">
    <div class="onb-linha tp-bloco">
      <span class="onb-ic onb-ic--pagamento"><i class="fab fa-whatsapp"></i></span>
      <div class="onb-tx">
        <b>Status e grupos do WhatsApp</b>
        <span>Mensagem pronta:</span>
        <pre class="tp-msg">{{ mensagem }}</pre>
        <div class="onb-acoes">
          <button type="button" class="onb-btn onb-btn--pri" *ngIf="podeCompartilhar" (click)="compartilhe()"><i class="fas fa-share-alt"></i> Compartilhar</button>
          <button type="button" class="onb-btn onb-btn--sec" (click)="copie(mensagem, 'msg')"><i class="far fa-copy"></i> {{ copiado === 'msg' ? 'Copiada' : 'Copiar mensagem' }}</button></div>
      </div>
    </div>
    <div class="onb-linha">
      <span class="onb-ic onb-ic--teste"><i class="fab fa-instagram"></i></span>
      <div class="onb-tx"><b>Bio do Instagram</b><span>Troque o link da bio pelo da sua loja.</span></div>
      <button type="button" class="onb-btn onb-btn--sec" (click)="copie(link, 'insta')">{{ copiado === 'insta' ? 'Copiado' : 'Copiar link' }}</button>
    </div>
    <div class="onb-linha">
      <span class="onb-ic onb-ic--neutro"><i class="fas fa-qrcode"></i></span>
      <div class="onb-tx"><b>QR no balcão e na embalagem</b><span>Imprima e cole onde o cliente vê.</span></div>
      <button type="button" class="onb-btn onb-btn--sec" (click)="imprimaQr()"><i class="fas fa-print"></i> Imprimir QR</button>
    </div>
  </div>

  <div class="tp-proximo">
    <div>
      <b>Seu painel cresce junto com a loja</b>
      <span>Agora entram Início, Novo pedido, Adicionais e Impressão. Clientes, Relatórios e Fidelidade chegam quando os pedidos começarem.</span>
    </div>
    <div class="onb-acoes tp-acoes">
      <button type="button" class="onb-btn onb-btn--pri onb-btn--grande" (click)="irParaOPainel()">Ir para o painel</button>
      <button type="button" class="onb-btn onb-btn--sec" (click)="irParaOPainel(true)">Quero ver o menu completo agora</button>
    </div>
  </div>
</div>
